import {
    isRouteErrorResponse,
    Links,
    Meta,
    MetaFunction,
    Outlet,
    Scripts,
    ScrollRestoration,
    useLoaderData,
    useRouteError,
} from "@remix-run/react"
import { captureRemixErrorBoundaryError, withSentry } from "@sentry/remix"
import { NavigationLoadingBar } from "./components/ui/navigation-loading-bar"
import "./tailwind.css"

export const meta: MetaFunction = () => {
    return [{ title: "Atécé | Service Portal" }, { name: "description", content: "Welcome to our service portal!" }]
}

export function ErrorBoundary() {
    const error = useRouteError()

    if (isRouteErrorResponse(error)) {
        return (
            <html lang="en">
                <div>
                    <h1 className="text-primary font-bold text-4xl mb-2">
                        {error.status} {error.statusText}
                    </h1>
                    <p>
                        {error.status == 404
                            ? "The page you were looking for doesn't exist!"
                            : "Something went wrong! Please try again later."}
                    </p>
                </div>
            </html>
        )
    }

    captureRemixErrorBoundaryError(error)

    return (
        <html lang="en">
            <div>
                <h1 className="text-primary font-bold text-4xl mb-2">500 Server Error</h1>
                <p>Something went wrong! Please try again later.</p>
            </div>
        </html>
    )
}

export function loader() {
    return {
        publicKeys: {
            SENTRY_ENV: process.env.SENTRY_ENV,
            VERSION: process.env.VERSION || "unknown",
            NODE_ENV: process.env.NODE_ENV,
        },
    }
}

function App() {
    const { publicKeys } = useLoaderData<typeof loader>()

    return (
        <html lang="en">
            <head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <Meta />
                <Links />
            </head>
            <body className="bg-white">
                <Outlet />
                <script
                    dangerouslySetInnerHTML={{
                        __html: `window.ENV = ${JSON.stringify(publicKeys)}`,
                    }}
                />
                <NavigationLoadingBar />
                <ScrollRestoration />
                <Scripts />
            </body>
        </html>
    )
}

export default withSentry(App)
